import { render, staticRenderFns } from "./SentDraft.vue?vue&type=template&id=484211e2&scoped=true&"
import script from "./SentDraft.vue?vue&type=script&lang=js&"
export * from "./SentDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484211e2",
  null
  
)

export default component.exports